import React from "react";
import SectionNav from "../Layout/SectionNav/SectionNav";

const CHACHOS_TABS = [
  { label: "Inicio",       to: "/chachos",                   exact: true  },
  { label: "Estadísticas", to: "/chachos/historical-stats"               },
  { label: "Fechas",       to: "/chachos/tournament-rounds"              },
  { label: "Jugadores",    to: "/chachos/squad"                          },
];

const ChachosMenu = () => (
  <SectionNav tabs={CHACHOS_TABS} accentColor="var(--color-chachos)" />
);

export default ChachosMenu;
